import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import Loading from 'apa/components/Loading';
import {Col, Row} from 'reactstrap';
import {
    createTemplateCategory,
    loadTemplateCategoryList,
    searchTemplate,
    selectTemplateCategory
} from 'template/actions';
import TemplateList from 'template/containers/TemplateList';
import TemplateCategoryControls from 'template/containers/TemplateCategoryControls';
import TemplateCategoryList from 'template/containers/TemplateCategoryList';

@connect(
    state => ({
        isLoading: state.template.isLoading,
        searchText: state.template.searchText,
        templateCategoryList: state.template.templateCategoryList
    }),
    dispatch => {
        return {
            loadCategoryList: () => dispatch(loadTemplateCategoryList()),
            selectCategory: (category) => dispatch(selectTemplateCategory(category)),
            createManualCategory: (category) => dispatch(createTemplateCategory(category)),
            searchManual: (searchText) => dispatch(searchTemplate(searchText))
        }
    }
)
export default class Main extends Component {

    componentDidMount() {
        this.props.loadCategoryList()
    }


    render() {
        const {
            searchText
        } = this.props;
        const {
            isLoading,
            templateCategoryList,
        } = this.props;
        if (isLoading)
            return <Loading/>;

        let filteredTemplateCategoryList = templateCategoryList
        if (searchText !== '') {
            filteredTemplateCategoryList = templateCategoryList.filter(
                category => category.name.toLowerCase().indexOf(searchText.toLowerCase()) !== -1
            )
        }
        return <Fragment>
            <TemplateCategoryControls/>
            <Row>
                <Col sm={4}>
                    <TemplateCategoryList templateCategoryList={filteredTemplateCategoryList}/>
                </Col>
                <Col sm={8}>
                    <TemplateList/>
                </Col>
            </Row>
        </Fragment>
    }
}
